export default {
  path: '/bankMasterData',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'index',
      name: 'index',
      component: () => import('@/pages/masterData/bankMasterData/index.vue'),
      meta: {
        keepAlive: true,
        title: '银行主数据',
      },
    },
  ],
};
